import React from 'react'
import Scroll from 'react-scroll'

import { COMPESO, CORTEC, DIESEL, KINOHELD } from '../constants/paymentProvider'
import CompesoIFrame from '../General/CompesoIFrame'
import KinoheldIFrame from '../General/KinoheldIFrame'
import KinoticketsIFrame from '../General/KinoticketsIFrame'
import DieselIFrame from '../General/DieselIframe'
import CortecIframe from '../General/CortecIframe'
import toJS from '../hoc/toJS'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { CLI, PROGRAM_CINEMAS, ROUTESDATA } from '../constants/state'
import getData from '../functions/getData'

let Element = Scroll.Element

const mapStateToProps = (state, ownProps) => ({
    routesData: getData(state, ROUTESDATA),
    cinemas: getData(state, PROGRAM_CINEMAS)
})

const PerformancePage = ({deeplinkURL, showId, routesData, cinemas, translation, scrollToPosition, cinema}) => {
    let iframe = null
    const currentCinema = cinemas[cinema]

    if(!currentCinema) {
        return ''
    }
    const cinemaDataProvider = currentCinema.scope.cinemaDataProvider
    const cinemaPath = cinemaDataProvider.type === KINOHELD ? cinemaDataProvider.kinoheldCinemaPath : cinemaDataProvider.type === COMPESO ? cinemaDataProvider.shopUrl : null
    const cinemaCenterId = cinemaDataProvider.type === COMPESO ? cinemaDataProvider.shopCenterId : null
    const { currentLang } = translation

    if(KINOHELD === cinemaDataProvider.type && cinemaPath){
        iframe = <KinoheldIFrame 
            cinemaPath={cinemaPath}
            showId={showId}
            baseUrl="https://www.kinoheld.de"
            deeplinkURL={deeplinkURL}
        />
    } else if(COMPESO === cinemaDataProvider.type && cinemaPath){
        iframe = <CompesoIFrame
            scrollToPosition={scrollToPosition}
            cinemaPath={cinemaPath}
            src={cinemaPath + "landingpage?center=" + cinemaCenterId + "&language=" + currentLang.toUpperCase() + "&page=seatingplan&performance=" + showId}
            id={'compeso-performance'}
        />
    } else if(DIESEL === cinemaDataProvider.type){
        iframe = <DieselIFrame
            showId={showId}
            currentCinema={currentCinema}
        />
    } else if(CORTEC === cinemaDataProvider.type){
        iframe = <CortecIframe
            showId={showId}
            routesData={routesData}
            scrollToPosition={scrollToPosition}
    />
    } else {
        iframe = <KinoticketsIFrame 
            deeplinkURL={deeplinkURL} />
    }

    return (
        <Element name={scrollToPosition + ' performance-iframe'} className="iframe-container">
            {iframe}
        </Element>

    )
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(PerformancePage)